module.exports = __webpack_public_path__ + "img/9.03998f87.jpg";